import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "close-octagon-outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-close-octagon-outline',
    templateUrl: './icon-close-octagon-outline.component.html',
    styleUrls: ['./icon-close-octagon-outline.component.scss'],
    standalone: false
})
export class IconCloseOctagonOutlineComponent   {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
